// In App.js
import React, { useState, useEffect } from 'react';
import Chat from './Chat';
import './App.css';

function App() {
  const [bootCompleted, setBootCompleted] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setBootCompleted(true);
    }, 3000); // Adjust duration as needed
  }, []);

  return (
    <div className="App">
      {bootCompleted ? (
        <Chat />
      ) : (
        <div className="boot-sequence">
          <p>Initializing system...</p>
          <p>Loading modules...</p>
          <p>Starting services...</p>
          <p>System ready.</p>
        </div>
      )}
    </div>
  );
}

export default App;
